/*
 * Podio Picker
 * Version 1.0
 * Written by: Kenneth Auchenberg
 *
 * Based on: Tokenizing Autocomplete Text Entry ( Copyright (c) 2009 James Smith (http://loopj.com, Licensed jointly under the GPL and MIT licenses,)
 *
 * Using underscore.js
 */

define('lib/jquery/jquery.podiopicker',['require','underscore','jquery','lib/Podio.UI.AutoCompleter','lib/Podio.Utils.Text','lib/Podio.Event','translate','jst!podio_picker/input_token'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var AutoCompleter = require('lib/Podio.UI.AutoCompleter');
  var textUtils = require('lib/Podio.Utils.Text');
  var PodioEvent = require('lib/Podio.Event');
  var t = require('translate');

  var jstInputToken = require('jst!podio_picker/input_token');

  $.fn.podioPicker = function(options) {
    if (!options) {
      options = {};
    }

    var settings = $.extend({
      placeholderText: t('Select or type to search'),
      hintText: t('Type in a search term'),
      searchDelay: 300,
      minChars: 1,
      tokenLimit: null,
      onResult: null,
      showTopList: true,
      onlyUnique: true,
      listCount: 12,
      alwaysShowTopList: false,
      initialFocusInInput: false,
      showAvatars : true,
      enableTouchSupport: false,
      selectFirstSearchOption: false,
      allowFreeTokens: false,
      freeTokenMode: '',
      customOption: false,
      showIconInToken: true,
      showFreeTokenAvatar: true,
      avatarFreeTokenPath: '',
      autoGrowInput: true,
      prePopulateAttribute: 'prepopulate',
      inputTokenIcon: 'icon-16-search',
      disabled: false,
      disableQueries: false,
      tooltip: null,
      autoCompleter: AutoCompleter,
      direction: 'bottom',
      showClearAll: false,
      syncToInput: true,
      onTokenAdded: null,
      onTokenRemoved: null,
      onAfterTokenAdded: null,
      onAfterTokenRemoved: null,
      onFreeTokenValidation: null,
      onFreeTokenAdded: null,
      onInputBlur: null,
      onOutsideClick: null,
      onTokensCleared: null,
      onNoResultsRendered: null,
      onResultsRendered: null,
    }, options);

    settings.classes = $.extend({
      tokenList: 'token-input-list',
      tokenListActive: 'active',
      token: 'token-input-token ',
      tokenDelete: 'token-input-delete-token img-ext',
      tokenLocked: 'token-input--is-locked',
      selectedToken: 'token-input-selected-token',
      highlightedToken: 'token-input-highlighted-token',

      inputToken: 'token-input-input-token',
      nonSelectable : 'non-selectable',
      clearAllWrapper: 'clear-all-wrapper',
      clearAllButton : 'icon-16-white-x-gray-circle'
    }, options.classes);

    settings.events = {
      reset : 'reset.picker.podio',
      getTokens : 'getTokens.picker.podio',
      getTokensComplete : 'getTokensComplete.picker.podio',
      populate: 'populate.picker.podio',
      clearAll: 'clearAll.picker.podio',
      hideAutocompleter: 'hideAutocompleter.picker.podio',
      customOption: 'podioPicker.customOption'
    };

    settings.tokenSources = {
      dropdown : 'dropdown',
      freetoken : 'freetoken'
    };

    return this.each(function() {
      new $.PodioPicker(this, settings);
    });
  };

  $.PodioPicker = function(input, settings) {
    var POSITION = { BEFORE: 0, AFTER: 1, END: 2 }; // Input box position "enum"
    var KEY = { BACKSPACE: 8, TAB: 9, RETURN: 13, ESC: 27, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, COMMA: 188, SPACE: 32 }; // Keys "enum"

    var charCodes = {
      comma: 44
    };

    var tokenCount = 0; // Keep track of the number of tokens in the list
    var timeout; // Keep track of the timeout

    var tokenListWidth;

    var elmInputBox, elmHiddenInput, elmTokenList, elmInputToken, elmAutoGrowHidden, elmPlaceholderLabel, elmWrapper;
    var inputAutoGrowMinWidth = 0, inputAutoGrowMaxWidth;
    var inputTokenPlaceholderLabelWidth = 0;

    var selectedToken = null, isInFocus = false;
    var currentTokens = [];

    var autoCompleter;

    function init() {
      // Keep a reference to the original input box
      elmHiddenInput = $(input).hide();

      elmHiddenInput.attr('data-is-podio-picker', 'true');

      // Create a new text input an attach keyup events
      var tabindex = elmHiddenInput.attr('tabindex');
      elmInputBox = $('<input>', { 'type': 'text', 'tabindex' : tabindex > 0 ? tabindex : null });
      elmInputBox.bind('keydown', onKeyDown);
      elmInputBox.bind('keypress', onKeyPress);
      elmInputBox.bind('input', onInputBoxInput);
      elmInputBox.focus(onInputboxFocus);
      elmHiddenInput.focus(onHiddenInputFocus);
      elmInputBox.blur(onInputboxBlur);

      // Remove any tab index and transfer any focus to visible box
      elmHiddenInput.attr('tabindex', 0);

      //Wrapper
      elmWrapper = $('<div />', {
        'class' : 'podio-picker-wrapper'
      });


      elmWrapper.insertAfter(elmHiddenInput);

      // The list to store the token items in
      elmTokenList = $('<ul />');

      elmTokenList.addClass(settings.classes.tokenList);
      elmTokenList.appendTo(elmWrapper);
      elmTokenList.bind('click', onTokenListClick);
      elmTokenList.bind('paste', onInputTokenPaste);

      if (settings.enableTouchSupport) {
        elmTokenList.bind('touchstart', onTokenListClick);
      }

      // Set Picker Width if any
      if(settings.pickerWidth) {
        elmTokenList.width(settings.pickerWidth);
      }

      elmHiddenInput.bind(settings.events.reset, onResetEvent);
      elmHiddenInput.bind(settings.events.getTokens, onGetTokensEvent);
      elmHiddenInput.bind(settings.events.populate, onPopulateEvent);
      elmHiddenInput.bind(settings.events.hideAutocompleter, onHideAutocompleterEvent);

      elmTokenList.delegate('li', 'mouseover', function (e) {
        var elmTarget = $(this);
        if (selectedToken !== this) {
          elmTarget.addClass(settings.classes.highlightedToken).siblings().removeClass(settings.classes.highlightedToken);
        }
      });

      elmTokenList.delegate('li', 'mouseout', function (e) {
        if (selectedToken !== this) {
          $(this).removeClass(settings.classes.highlightedToken);
        }
      });

      elmTokenList.delegate('li', 'mousedown', function (e) {
        // Stop user selecting text on tokens, but allow right click
        var elmTarget = $(e.currentTarget);

        // Allow text selection in input token
        if(elmTarget.is('.' + settings.classes.inputToken)) {
          return true;
        }

        if (e.button != 2) {
          return false;
        }
      });

      elmTokenList.delegate('li span.delete', 'click', function() {
        deleteToken($(this).parent());
        return false;
      });

      // Bind on the insertToken event to allow 3rd parties to insert tokens
      elmHiddenInput.bind('podioPicker.insertToken', function(e, item) {
        insertToken(item.id, item.name, (item.itemIcon || item.icon), item.avatar);
        currentTokens.push(item);
        syncTokenValuesToInput();
        elmInputBox.val('');
      });

      // The token holding the input box
      elmInputToken = $('<li />').addClass(settings.classes.inputToken);
      elmInputToken.appendTo(elmTokenList);

      var inputTokenHtml = jstInputToken({
        icon: settings.inputTokenIcon,
        placeholderText : settings.placeholderText
      });

      elmInputToken.html(inputTokenHtml);

      // Input field
      elmInputToken.find('.input-box').append(elmInputBox);

      // Detect length of placeholder text to make it adjust the width of the label, to avoid line wrapping
      elmPlaceholderLabel = elmInputToken.find('label');

      var elmLabelWidthDetection = $('<div/>', { 'class' : 'podio-picker-label-autogrow-helper', 'text':  settings.placeholderText }).css({
          position: 'absolute',
          top: -999999,
          left: -99999,
          width: 'auto',
          fontSize: elmPlaceholderLabel.css('fontSize'),
          fontFamily: elmPlaceholderLabel.css('fontFamily'),
          fontWeight: elmPlaceholderLabel.css('fontWeight'),
          letterSpacing: elmPlaceholderLabel.css('letterSpacing'),
          whiteSpace: 'nowrap'
        }).appendTo('body');

      // 18 left + 10 right + 20 image
      inputTokenPlaceholderLabelWidth = elmLabelWidthDetection.width() + 48;
      elmInputBox.width(inputTokenPlaceholderLabelWidth);

      elmLabelWidthDetection.remove();

      // Input auto grow support
      if (settings.autoGrowInput) {
        elmInputBox.bind('input', onAutoGrowInput);

        inputAutoGrowMinWidth = elmInputBox.width();
        inputAutoGrowMaxWidth = elmTokenList.width() - 48;

        // This element is used to calculate the width of the input field when typing
        elmAutoGrowHidden = $('.podio-picker-autogrow-helper');
        if (!elmAutoGrowHidden.length) {
          elmAutoGrowHidden = $('<div/>', { 'class' : 'podio-picker-autogrow-helper'}).css({
            position: 'absolute',
            top: -999999,
            left: -99999,
            width: 'auto',
            fontSize: elmInputBox.css('fontSize'),
            fontFamily: elmInputBox.css('fontFamily'),
            fontWeight: elmInputBox.css('fontWeight'),
            letterSpacing: elmInputBox.css('letterSpacing'),
            whiteSpace: 'nowrap'
          }).appendTo('body');
        }
      }

      // Clear all button
      if (settings.showClearAll) {
        var elmClearAllWrapper = elmTokenList.wrap($('<div/>', { 'class': settings.classes.clearAllWrapper}));
        var elmClearAllButton = $('<span/>', { 'class': 'clear-all-button icon-16 ' + settings.classes.clearAllButton });
        elmClearAllButton.appendTo(elmClearAllWrapper);
        elmClearAllButton.bind('click', onClearAllButtonClick);
        elmHiddenInput.bind(settings.events.clearAll, onClearAllEvent);
      }

      // Disable if input is disabled
      if(!settings.disabled) {
        settings.disabled = elmHiddenInput.is(':disabled');
      }
      if(settings.disabled) {
        elmTokenList.addClass('disabled');
      }

      // Get tooltip from input if not given in settings
      settings.tooltip = settings.tooltip || elmHiddenInput.attr('title');
      if(settings.tooltip) {
        elmTokenList.attr('title', settings.tooltip);
        elmTokenList.addClass('tooltip');
      }

      tokenListWidth = elmTokenList.width();
    }

    function initList() {
      var prePopulateData = settings.prePopulate || elmHiddenInput.data(settings.prePopulateAttribute);

      if (prePopulateData && prePopulateData.length) {

        for (var i = 0; i < prePopulateData.length; i++) {
          var item = prePopulateData[i];
          insertToken(item.id, item.name, (item.itemIcon || item.icon), item.avatar, item.locked);
          item.source = settings.tokenSources.dropdown;
          currentTokens.push(item);
          tokenCount++;
        }

        syncTokenValuesToInput();
        checkTokenLimitReached();
      }


      // Don't show the help dropdown, they've got the idea
      hideDropdown();

      // Clear input box and make sure it keeps focus
      elmInputBox.val('');
      if (settings.initialFocusInInput) {
        elmInputBox.focus();
      }

      // Toggle no-tokens class
      handleTokensChanged();

    }

    function initAutocomplete() {

      autoCompleter = new settings.autoCompleter(elmWrapper, {
        selectFirstItem : !settings.allowFreeTokens,
        useAbsolutePosition: settings.direction === 'top',
        direction: settings.direction
      });

      autoCompleter.signals.onItemSelected.add(function(item) {

        if(!item) {
          throw('No item passed from autocompleter. Something is wrong.');
        }

        if(item.custom) {
          elmHiddenInput.trigger(settings.events.customOption, {
            'item' : item,
            'hiddenInput' : elmHiddenInput,
            'tokenInput' : elmInputBox
          });
        } else {
          addToken(item);
        }

        hideDropdown();

        if (settings.showTopList && (!isLimitReached() || settings.alwaysShowTopList)) {
          showDropdownToplist();
        }

        // if(elmTarget.hasClass(settings.classes.nonSelectable)) {
        //   return false;
        // }
      });

    }

    init();
    initAutocomplete();
    initList();
    PodioEvent.bind('resize', updatePosition);

    //
    // Functions
    //

    function updatePosition() {
      if (settings.direction === 'top') {
        autoCompleter.updatePosition();
      } else {
        updateAutoCompletePosition();
      }
    }

    function updateAutoCompletePosition() {

      if(!elmTokenList.is(':visible')) {
        // Dont try to get position from an invisible element in IE, since it will thrown an exception (http://www.west-wind.com/weblog/posts/2008/Sep/20/jQueryposition-on-Invisible-Elements-fails)
        return;
      }

      var bounds = elmTokenList.position();
      var width = elmTokenList.outerWidth();

      elmWrapper.find('.podio-autocompleter ul').css({
        top: elmTokenList.height() + bounds.top,
        left: bounds.left,
        width: width
      });
    }

    function onResetEvent() {
      currentTokens = [];
      tokenCount = 0;
      elmInputBox.val('');
      elmTokenList.find('.' + settings.classes.token).remove();

      hideDropdown();
      syncTokenValuesToInput();
      handleTokensChanged();

      elmInputBox.parents('.' + settings.classes.inputToken + ':first').removeClass('disabled');
    }

    function onGetTokensEvent() {
      elmHiddenInput.trigger(settings.events.getTokensComplete, $.extend( {}, currentTokens));

      // Plan blurring in the next tick to ensure correct execution order
      setTimeout(function(){
        elmInputBox.blur()
      },0);
    }

    function onPopulateEvent(e, prePopulate) {
      onResetEvent();
      settings.prePopulate = prePopulate;
      initList();
    }

    function onHideAutocompleterEvent() {
      hideDropdown();
    }

    function getInputBoxValue(trim) {
      val = elmInputBox.val()
      if (_.isUndefined(trim) || trim) {
        val = val.trim();
      }
      return val;
    }

    function extractEmails(input) {

      // Added small JsFiddle/Test to verify this is working with apple/gmail/outlook formats
      // http://jsfiddle.net/auchenberg/gg5DX/

      // Split input by delimiters
      values = input.split(/[\n\s,;]+/g);

      // Map values
      var emails = _.compact(_.map(values, function(value) {

        // Remove < in start, > in end
        value = value.replace(/(^<)|(>$)/g, '');

        // Check if valid email
        if( textUtils.isValidEmail(value) ) {
          return value;
        }

      }));

      return emails;
    }

    function onInputTokenPaste() {
      if (settings.allowFreeTokens && settings.freeTokenMode == 'email') {

        _.defer(function() {
          var value = getInputBoxValue();
          var emails = extractEmails(value);

          _.each(emails, function(email) {
            addFreeToken(email);
          });

        });
      }
    }

    // bidirectional focus propagation. When triggered on hidden input, it will focus the picker. When picker focuses
    // it will trigger a focus event on the original hidden input.
    function onHiddenInputFocus(e, triggeredBySelf) {
      // do not circulate events
      if (triggeredBySelf === true) {
        return true;
      }

      elmInputBox.trigger('focus');
    }

    function onInputboxFocus() {
      elmHiddenInput.trigger('focus', true);

      handleInputTokenValue();
      isInFocus = true;
      elmTokenList.toggleClass(settings.classes.tokenListActive, isInFocus);

      if(settings.disableQueries) {
        return;
      }

      var query = getInputBoxValue();
      if (query) {
        doSearch();
      } else if (settings.showTopList && (!isLimitReached() || settings.alwaysShowTopList)) {
        showDropdownToplist();
      }

      // we want to prevent duplicate event binding when focus is triggered by user clicking in the autocompleter
      if (!onOutsideClick.bound) {      /* function is just an object in JS */
        elmTokenList.bind('outsideclick', onOutsideClick);
        onOutsideClick.bound = true;
      }
    }

    function onTokenListClick(e) {
      if(elmTokenList.hasClass('disabled')) {
        return;
      }

      var li = $(e.target).closest('li');
      if (li && li.get(0) != elmInputToken.get(0)) {
        toggleSelectToken(li);
      } else {
        elmInputBox.focus();
        if (selectedToken) {
          deselectToken($(selectedToken), POSITION.END);
        }
      }
    }

    function onAutoGrowInput() {
      // Enter new content into elmAutoGrowHidden
      var inputboxValue = getInputBoxValue(false);
      inputboxValue = inputboxValue.replace(/ /g, '\u00A0');//Replace with proper space as the text is trimmed

      elmAutoGrowHidden.text(inputboxValue);

      // Calculate new width
      var newWidth = Math.max(elmAutoGrowHidden.width(), inputAutoGrowMinWidth);
      if (inputAutoGrowMaxWidth > 0) {
        newWidth = Math.min(inputAutoGrowMaxWidth, newWidth);
      }

      elmInputToken.width('auto');
      elmInputBox.width(newWidth);
    }

    // outsideclick only triggers when the click event occured outside
    // the whole picker container (blur also fires if clicked inside), and only if the picker is visible
    function onOutsideClick(e) {
      if (elmTokenList.is(':visible') && _.isFunction(settings.onOutsideClick)) {
        settings.onOutsideClick.call(this, e, _.pluck(currentTokens, 'id').join(','));
      }

      elmTokenList.unbind('outsideclick', onOutsideClick);
      onOutsideClick.bound = false; /* function is just an object in JS */
    }

    function onInputboxBlur(e) {
      if (_.isFunction(settings.onInputBlur)) {
        if (settings.onInputBlur.apply(this, [e]) === false) {
          return false;
        }
      }

      if (settings.allowFreeTokens) {
        handleOutsideclickFreeTokens();
      }
      isInFocus = false;

      elmTokenList.toggleClass(settings.classes.tokenListActive, isInFocus);

      hideDropdown();
    }

    function onClearAllButtonClick(e) {
      elmHiddenInput.trigger(settings.events.clearAll);
      e.stopPropagation();
    }

    function onClearAllEvent(e) {
      if(tokenCount > 0) {
        elmHiddenInput.trigger(settings.events.reset);
        if(_.isFunction(settings.onTokensCleared)) {
          settings.onTokensCleared(elmTokenList);
        }
        return true;
      } else {
        return false;
      }
    }

    function handleOutsideclickFreeTokens() {
      var value = getInputBoxValue();
      if (!value.isEmpty()) {
        addFreeToken(value, { bypassFocus : true });
      }
    }

    function handleEmailFreeTokenMode() {
      if (settings.allowFreeTokens && settings.freeTokenMode == 'email' && getInputBoxValue().indexOf('@') > -1) {
        hideDropdown();
        return true;
      }
      return false;
    }

    function handleTokensChanged() {
      // Toggle no-tokens class
      if( tokenCount === 0 ) {
        elmTokenList.addClass('no-tokens');
        elmWrapper.addClass('no-tokens-wrapper');
      } else {
        elmTokenList.removeClass('no-tokens');
        elmWrapper.removeClass('no-tokens-wrapper');
      }
    }

    // Hide and clear the results dropdown
    function hideDropdown() {
      autoCompleter.hide();
    }

    function showDropdownToplist() {

      if(settings.disableQueries) {
        return;
      }

      autoCompleter.renderLoading();
      updatePosition();
      clearTimeout(timeout);
      requestData('toplist', '');
    }

    function showDropdownSearching() {

      if(settings.disableQueries) {
        return;
      }

      autoCompleter.renderLoading();
      updatePosition();
    }

    function onTokenizingKeyPressed(e) {
      if (settings.allowFreeTokens) {
        var value = getInputBoxValue();
        var autoCompleteActiveItem = autoCompleter.getActiveItemData();

        if (autoCompleteActiveItem || value) {
          //If we added an item or a free token, eat the event
          e.stopPropagation();
          e.preventDefault();
        }

        if (autoCompleteActiveItem) {
          addToken(autoCompleteActiveItem);
        } else if (value) {
          addFreeToken(value);
          hideDropdown();
        }
      }
    }

    // handles special keys
    function onKeyDown(event) {

      var previousToken;
      var nextToken;
      var value;

      switch (event.keyCode) {
        case KEY.LEFT:
        case KEY.RIGHT:
          if (!$(this).val()) {
            previousToken = elmInputToken.prev();
            nextToken = elmInputToken.next();

            if ((previousToken.length && previousToken.get(0) === selectedToken) || (nextToken.length && nextToken.get(0) === selectedToken)) {
              // Check if there is a previous/next token and it is selected
              if (event.keyCode == KEY.LEFT) {
                deselectToken($(selectedToken), POSITION.BEFORE);
              } else {
                deselectToken($(selectedToken), POSITION.AFTER);
              }
            } else if ((event.keyCode == KEY.LEFT) && previousToken.length) {
              // We are moving left, select the previous token if it exists
              selectToken($(previousToken.get(0)));
            } else if ((event.keyCode == KEY.RIGHT) && nextToken.length) {
              // We are moving right, select the next token if it exists
              selectToken($(nextToken.get(0)));
            }
          }
          break;

        case KEY.BACKSPACE:
          previousToken = elmInputToken.prev();
          if (!$(this).val().length) {
            if (selectedToken) {
              deleteToken($(selectedToken));
            } else if (previousToken.length) {
              selectToken($(previousToken.get(0)));
            }

            return false;
          } else if ($(this).val().length == 1) {
            hideDropdown();
            if (settings.showTopList) {
              showDropdownToplist();
            }
          } else {
            setTimeout(function() {
              doSearch();
            }, 5); // set a timeout just long enough to let this function finish.
          }
          break;

        case KEY.RETURN:
        case KEY.TAB:
          onTokenizingKeyPressed(event);
          break;

        case KEY.SPACE:
          value = getInputBoxValue();
          if (settings.freeTokenMode == 'email' && textUtils.isValidEmail(value)) {
            event.preventDefault();
            addFreeToken(value);
          }
          break;

        case KEY.ESC:
          hideDropdown();
          return true;
      }
    }

    function onInputBoxInput(e) {
      _.defer(doSearch);
    }

    function onKeyPress(event) {
      var charCode = event.which;

      if (charCode === charCodes.comma) {
        onTokenizingKeyPressed(event);
      }

    }

    function handleInputTokenValue() {
      var elmInput = elmInputToken.find('input');

      if (elmInput.length && elmInput.val().length) {
        elmInputToken.addClass('typed');
      } else {
        elmInputToken.removeClass('typed');
      }
    }


    function renderImageIcon(prop, elmTarget) {
      $('<img />', { 'class' : 'img', 'src' : prop }).prependTo(elmTarget);
    }

    function renderIcon(prop, elmTarget) {
      $('<div />', { 'class' : 'icon img ' + prop }).prependTo(elmTarget);
    }

    // Inner function to a token to the list
    function insertToken(id, value, icon, avatar, locked) {

      var elmTokenItem = $('<li />', { 'data-id' :String(id).htmlEncode(), 'data-locked': !!locked });


      if (icon) {

        if (icon.indexOf('/') > -1 ) { // Not a valid CSS class with / => image
          renderImageIcon(icon, elmTokenItem);
        } else {
          renderIcon(icon, elmTokenItem);
        }

      } else if (avatar) {
        renderImageIcon(avatar, elmTokenItem);
      }

      elmTokenItem.addClass(settings.classes.token);
      elmTokenItem.insertBefore(elmInputToken);

      // The 'delete token' button
      if (!locked) {
        var elmDeleteButton = $('<span />', { text : 'x', class : settings.classes.tokenDelete + ' delete'});
        elmDeleteButton.appendTo(elmTokenItem);
      } else {
        elmTokenItem.addClass(settings.classes.tokenLocked);
      }

      var elmTokenItemText = $('<p />', { 'class' : 'bd', 'html': value.htmlEncode() }).appendTo(elmTokenItem);

      // Adjust width of p-tag that contains text, to ensure that tokens with long text has visible text and is being cropped correctly
      elmTokenItemText.css('max-width', tokenListWidth - 55);
      elmTokenItem.css('max-width', tokenListWidth - 13);

      return elmTokenItem;
    }

    function addFreeToken(value, options) {

      if (!value.length) {
        return;
      }

      var id = value;
      var name = value;

      if (settings.onFreeTokenValidation) {
        result = settings.onFreeTokenValidation.apply(this, [id]);
        if (!result) {
          return;
        }
      }

      if (settings.onFreeTokenAdded) {
        result = settings.onFreeTokenAdded.apply(this, [id]);
        if (!result) {
          return;
        }
        else if (typeof(result) === 'object') {
          // Returned object with new id and name
          id = result.id;
          name = result.name;
        }
      }

      if (settings.freeTokenMode === 'email' && !textUtils.isValidEmail(name)) {
        return;
      }

      if (settings.onlyUnique) {
        if (isTokenUnique(id)) {
          hideDropdown();

          elmTokenList.find('li').filter(function() {
            return $(this).data('id') === id;
          }).effect('highlight');

          elmInputBox.val('').focus();
          return true;
        }
      }

      currentTokens.push({id: id, name: name, source : settings.tokenSources.freetoken});

      if (settings.showFreeTokenAvatar) {
        insertToken(id, name, null, settings.avatarFreeTokenPath);
      } else {
        insertToken(id, name, null);
      }


      if (settings.autoGrowInput) {
        elmInputBox.css('width', '');
      }

      elmInputBox.val('');

      if (!options || !options.bypassFocus) {
        // Clear input box and make sure it keeps focus
        elmInputBox.focus();
      }

      handleInputTokenValue();
      syncTokenValuesToInput();

      tokenCount++;

      handleTokensChanged();

      updateInputTokenPlaceholder();

      if (isLimitReached()) {
        elmInputBox.parents('.' + settings.classes.inputToken + ':first').addClass('disabled');
        hideDropdown();
      }

      if (_.isFunction(settings.onAfterFreeTokenAdded)) {
        settings.onAfterFreeTokenAdded.apply(this, [value, tokenCount]);
      }
    }

    function updateInputTokenPlaceholder() {
      elmInputToken.width(inputTokenPlaceholderLabelWidth);
    }

    function isTokenUnique(tokenId) {

      return !_.isUndefined(_.detect(currentTokens, function(item) {

        if ( !_.isUndefined(item.id) && !_.isUndefined(tokenId) && !_.isNull(item.id) && !_.isNull(tokenId) ) {
          return item.id.toString() === tokenId.toString();
        }

        return false;

      }));

    }

    function isLimitReached() {
      return settings.tokenLimit !== null && settings.tokenLimit <= tokenCount;
    }

    // Add a token to the token list based on user input
    function addToken(itemData) {

      if (settings.onlyUnique) {
        if (isTokenUnique(itemData.id)) {
          hideDropdown();

          var elmTokens = elmTokenList.find('li').filter(function() {
            return $(this).attr('data-id') === itemData.id;
          });

          elmTokens.effect('highlight');

          elmInputBox.val('').focus();
          return true;
        }
      }

      if ($.isFunction(settings.onTokenAdded)) {
        if (!settings.onTokenAdded(elmTokenList, itemData)) {
          elmInputBox.val('');
          hideDropdown();
          return true;
        }
      }

      itemData.source = settings.tokenSources.dropdown;

      currentTokens.push(itemData);

      if (settings.showIconInToken) {
        insertToken(itemData.id, itemData.name, (itemData.itemIcon || itemData.icon), itemData.avatar);
      } else {
        insertToken(itemData.id, itemData.name);
      }
      tokenCount++;

      // Clear input box and make sure it keeps focus
      elmInputBox.val('');
      if (!isLimitReached()) {
        elmInputBox.focus();
      }

      if (settings.autoGrowInput) {
        elmInputBox.css('width', '');
      }

      handleInputTokenValue();
      syncTokenValuesToInput();

      checkTokenLimitReached();
      handleTokensChanged();
      updateInputTokenPlaceholder();

      if ($.isFunction(settings.onAfterTokenAdded)) {
        settings.onAfterTokenAdded(currentTokens, itemData.id);
      }
    }

    function checkTokenLimitReached() {
      if (isLimitReached()) {
        elmInputBox.parents('.' + settings.classes.inputToken + ':first').addClass('disabled');
        elmInputBox.val('');
        hideDropdown();
      }
    }

    function syncTokenValuesToInput() {
      if (settings.syncToInput) {
        var tokenValues = _.pluck(currentTokens, 'id');
        var freeTokens = _.pluck(_.select(currentTokens, function(token) { return token && token.source == settings.tokenSources.freetoken; }), 'id');
        var dropdownTokens = _.pluck(_.select(currentTokens, function(token) { return token && token.source == settings.tokenSources.dropdown; }), 'id');

        elmHiddenInput.val(tokenValues.join(','));
        elmHiddenInput.attr('data-tokens-free', freeTokens.join(','));
        elmHiddenInput.attr('data-tokens-dropdown', dropdownTokens.join(','));
        elmHiddenInput.data('tokens', currentTokens);
      }
    }

    // Select a token in the token list
    function selectToken(token) {
      token.addClass(settings.classes.selectedToken);
      selectedToken = token.get(0);

      // Hide input box
      elmInputBox.val('');

      hideDropdown();
    }

    // Deselect a token in the token list
    function deselectToken(token, position) {
      token.removeClass(settings.classes.selectedToken);
      selectedToken = null;

      if (position == POSITION.BEFORE) {
        elmInputToken.insertBefore(token);
      } else if (position == POSITION.AFTER) {
        elmInputToken.insertAfter(token);
      } else {
        elmInputToken.appendTo(elmTokenList);
      }

      // Show the input box and give it focus again
      // Inside a timeout to break code execution and allow focus in IE7+8
      setTimeout(function() {
        elmInputBox.focus();
      }, 1);
    }

    // Toggle selection of a token in the token list
    function toggleSelectToken(token) {
      if (selectedToken == token.get(0)) {
        deselectToken(token, POSITION.END);
      } else {
        if (selectedToken) {
          deselectToken($(selectedToken), POSITION.END);
        }
        selectToken(token);
      }
    }

    // Delete a token from the token list
    function deleteToken(token) {
      if (token.data('locked')) {
        return;
      }
      var tokenId = token.attr('data-id').htmlDecode().trim();
      if ($.isFunction(settings.onTokenRemoved)) {
        var token_data = _.detect(currentTokens, function(item){ return item.id.toString().trim() == tokenId; });
        if (!settings.onTokenRemoved(elmTokenList, token_data)) {
          hideDropdown();
          elmInputBox.val('');
          return true;
        }
      }

      // Delete the token
      token.remove();
      selectedToken = null;

      currentTokens = _.reject(currentTokens, function(item){ return item.id.toString().trim() == tokenId; });

      // Show the input box and give it focus again
      elmInputBox.focus();

      elmInputBox.val('');
      hideDropdown();
      syncTokenValuesToInput();

      tokenCount--;

      handleTokensChanged();

      if (settings.tokenLimit !== null) {
        elmInputBox.parents('.' + settings.classes.inputToken + ':first').removeClass('disabled');
        elmInputBox.val('').focus();
      }

      if ($.isFunction(settings.onAfterTokenRemoved)) {
        settings.onAfterTokenRemoved(currentTokens, tokenId);
      }
    }

    // Do a search and show the "searching" dropdown if the input is longer
    // than settings.minChars
    function doSearch() {

      var query = getInputBoxValue();
      handleInputTokenValue();

      if (settings.disableQueries) {
        return;
      }

      if (query && query.length) {
        if (selectedToken) {
          deselectToken($(selectedToken), POSITION.AFTER);
        }

        if (handleEmailFreeTokenMode()) {
          return;
        }

        if (query.length >= settings.minChars) {

          showDropdownSearching();

          clearTimeout(timeout);
          timeout = setTimeout(function() {
            requestData('search', query);
          }, settings.searchDelay);
        } else {
          hideDropdown();
        }
      } else if (settings.showTopList && !isLimitReached()) {
        showDropdownToplist();
      }
    }

    function filterUniqueItems(items) {
      return _.filter(items, function(item, index) {

        if (item.type && item.type == 'group') {
          item.items = filterUniqueItems(item.items);
        }

        return !isTokenUnique(item.id);
      });
    }

    function requestData(mode, query) {

      var customOptionId = 'custom-option';

      // Don't send query if it's a search for the placeholderText
      if (query == settings.placeholderText) {
        query = '';
      }

      settings.onDataRequest(mode, query, function(responseData) {

        if (!isInFocus) {
          return; // Not in focus, no need to render.
        }

        var existingCustomOption = _.find(responseData, function(item, index) {
          return item.id == customOptionId;
        });

        // Custom options
        if (settings.customOption !== false && !existingCustomOption) {
          responseData.push({
            custom: true,
            id: customOptionId,
            name: settings.customOption.label,
            itemIcon: settings.customOption.avatar,
            className : settings.customOption.className
          });
        }

        // Callbacks
        if ($.isFunction(settings.onResult)) {
          responseData = settings.onResult.call(this, responseData);
        }

        // Filter out existing tokens;
        var filteredItems = filterUniqueItems(responseData);

        if (!filteredItems.length) {
          if(settings.onNoResultsRendered) {
            settings.onNoResultsRendered();
          }
        } else {
          if (settings.onResultsRendered) {
            settings.onResultsRendered();
          }
        }

        // Update UI
        updatePosition();
        autoCompleter.populate(filteredItems, query);

      });
    }

  };

});

